/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_UnlinkInputs */



/**
* | output |
* | --- |
* | "Unlink" |
*
* @param {Profile_UnlinkInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const profile_unlink = /** @type {((inputs?: Profile_UnlinkInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_UnlinkInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Délier")
	if (locale === "es") return /** @type {LocalizedString} */ ("Desvincular")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Desvincular")
	if (locale === "it") return /** @type {LocalizedString} */ ("Scollega")
	return /** @type {LocalizedString} */ ("Unlink")
});